<template>
<div class="chapter">
<div class="inner_page">
<div class="toc">
<a id="title18"></a>
<div class="toc_entry"><a class="toc_entry_frontMatter" href="#/9781459268975_fm01"><span><em class="i"><strong class="b">“Are you saying you’d marry if you met the right man?”</strong></em></span></a><br/>
<a class="toc_entry_aboutAuthorPage" href="#/9781459268975_ata01"><span>About the Author</span></a><br/>
<a class="toc_entry_titlePage" href="#/9781459268975_tp01"><span>Title Page</span></a><br/>
<a class="toc_entry_frontMatter" href="#/9781459268975_fm02"><span>PROLOGUE</span></a><br/>
<a class="toc_entry_chapter" href="#/9781459268975_c01"><span>CHAPTER ONE</span></a><br/>
<span class="toc_entry_chapter" href="#/9781459268975_c02" title="Link target outside of Sample"><span>CHAPTER TWO</span></span><br/>
<span class="toc_entry_chapter" href="#/9781459268975_c03" title="Link target outside of Sample"><span>CHAPTER THREE</span></span><br/>
<span class="toc_entry_chapter" href="#/9781459268975_c04" title="Link target outside of Sample"><span>CHAPTER FOUR</span></span><br/>
<span class="toc_entry_chapter" href="#/9781459268975_c05" title="Link target outside of Sample"><span>CHAPTER FIVE</span></span><br/>
<span class="toc_entry_chapter" href="#/9781459268975_c06" title="Link target outside of Sample"><span>CHAPTER SIX</span></span><br/>
<span class="toc_entry_chapter" href="#/9781459268975_c07" title="Link target outside of Sample"><span>CHAPTER SEVEN</span></span><br/>
<span class="toc_entry_chapter" href="#/9781459268975_c08" title="Link target outside of Sample"><span>CHAPTER EIGHT</span></span><br/>
<span class="toc_entry_chapter" href="#/9781459268975_c09" title="Link target outside of Sample"><span>CHAPTER NINE</span></span><br/>
<span class="toc_entry_chapter" href="#/9781459268975_c10" title="Link target outside of Sample"><span>CHAPTER TEN</span></span><br/>
<span class="toc_entry_chapter" href="#/9781459268975_c11" title="Link target outside of Sample"><span>CHAPTER ELEVEN</span></span><br/>
<span class="toc_entry_chapter" href="#/9781459268975_c12" title="Link target outside of Sample"><span>CHAPTER TWELVE</span></span><br/>
<span class="toc_entry_chapter" href="#/9781459268975_c13" title="Link target outside of Sample"><span>CHAPTER THIRTEEN</span></span><br/>
<span class="toc_entry_chapter" href="#/9781459268975_c14" title="Link target outside of Sample"><span>CHAPTER FOURTEEN</span></span><br/>
<span class="toc_entry_backMatter" href="#/9781459268975_bm01" title="Link target outside of Sample"><span>EPILOGUE</span></span><br/>
<span class="toc_entry_pubInfo" href="#/9781459268975_cop01" title="Link target outside of Sample"><span>Copyright</span></span><br/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781459268975_toc01.vue?577a08b6